

export function setAccountsFrom(state, accounts_from) {
    state.accounts_from = accounts_from
}

export function setBranchOffices(state, Branchoffices) {
    state.branchoffices = Branchoffices;
}

export function setWarehouses(state, Warehouses) {
    state.warehouses = Warehouses;
}
export function setconciation_balances(state, reporte_comisiones) {
    state.conciliation_balances = reporte_comisiones
    //console.log(reporte_comisiones);
}
export function setParams(state, params){
    state.params = params
}



// WEBPACK FOOTER //
// ./src/modules/conciliation-balances/mutations.js